// import { isDate } from 'lodash'
// import { format } from 'date-fns'

/**
 * Convert date string or object into date object
 * @param  {[type]} [dateValue=null] - Date value which to format
 * @return {Date} Formatted time
 */
// export function getDateObject(dateValue = null) {
// 	return isDate(dateValue) ? dateValue : new Date(dateValue)
// }

/**
 * Format date to time with am/pm
 * @param  {[type]} dateValue - Date value which to format
 * @return {String} Formatted time
 */
// export function formatTime(dateValue) {
// 	return format(getDateObject(dateValue), 'h:mm:ss.SSS A')
// }

/**
 * Format date string or object into date string with format 1/22/2018
 * @param  {Object} dateValue - Date value which to format
 * @return {String} Formatted date
 */
// export function formatDate(dateValue) {
// 	return format(getDateObject(dateValue), 'MM/DD/YY')
// }

/**
 * Format date string or object into date string with format
 * 1/22/2018 - 3:30:25.123 AM
 * @param  {Object} dateValue - Date value which to format
 * @return {String} Formatted date
 */
// export function formatDateTime(dateValue) {
// 	return format(getDateObject(dateValue), 'MM/DD/YY - h:mm:ss.SSS A')
// }

export function getUuid() {
	const S4 = () => {
		return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
	}
	return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4()
}

export function fixedFromCharCode(code) {
	/* eslint-disable no-bitwise */
	if (code > 0xffff) {
		code -= 0x10000

		let surrogate1 = 0xd800 + (code >> 10)
		let surrogate2 = 0xdc00 + (code & 0x3ff)

		return String.fromCharCode(surrogate1, surrogate2)
	}

	return String.fromCharCode(code)
}

// Char to Int, with fix for big numbers
//
export function fixedCharCodeAt(chr) {
	/* eslint-disable no-bitwise */
	let char1 = chr.charCodeAt(0)
	let char2 = chr.charCodeAt(1)

	if (chr.length >= 2 && (char1 & 0xfc00) === 0xd800 && (char2 & 0xfc00) === 0xdc00) {
		return 0x10000 + ((char1 - 0xd800) << 10) + (char2 - 0xdc00)
	}

	return char1
}

export function __copyToClipboard(copyContext) {
	var textArea = document.createElement('textarea')
	textArea.value = copyContext
	document.body.appendChild(textArea)
	textArea.select()
	try {
		 document.execCommand('copy')
	} catch (err) {
		/* eslint-disable no-console */
		console.error('Fallback: Oops, unable to copy', err)
		/* eslint-disable no-console */
	}
	document.body.removeChild(textArea)
}

export function copyTextToClipboard(text) {
	if (!navigator.clipboard) {
		__copyToClipboard(text)
		return
	}
	navigator.clipboard.writeText(text).then(
		function() {
			return true
		},
		function(err) {
			/* eslint-disable no-console */
			console.error('Async: Could not copy text: ', err)
			/* eslint-disable no-console */
		}
	)
}
